import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M960,15 L1226.66667,256.92 L1586.56,243.053333 L1635.30667,599.96 L1920,820.546667 L1728,1125.18667 L1804.26667,1477.29333 L1461.33333,1587.16 L1293.44,1905.77333 L960,1769.56 L626.56,1905.77333 L458.666667,1587.16 L115.733333,1477.29333 L192,1125.18667 L0,820.546667 L284.693333,599.96 L333.44,243.053333 L693.333333,256.92 L960,15 Z M960,159 L764.906667,335.96 L732.693333,365.186667 L689.173333,363.586667 L425.92,353.453333 L390.293333,614.36 L384.426667,657.56 L349.973333,684.12 L141.866667,845.506667 L282.24,1068.44 L305.493333,1105.13333 L296.213333,1147.8 L240.533333,1405.18667 L491.306667,1485.61333 L532.8,1498.94667 L553.173333,1537.45333 L675.84,1770.41333 L919.68,1670.89333 L960,1654.36 L1000.32,1670.89333 L1244.16,1770.41333 L1366.93333,1537.45333 L1387.2,1498.94667 L1428.69333,1485.61333 L1679.46667,1405.18667 L1623.78667,1147.8 L1614.50667,1105.13333 L1637.76,1068.44 L1778.24,845.506667 L1570.02667,684.12 L1535.57333,657.56 L1529.70667,614.36 L1493.97333,353.453333 L1230.93333,363.586667 L1187.30667,365.186667 L1155.09333,335.96 L960,159 Z M1301.056,772.482667 L1365.58933,857.496 L803.989333,1283.736 L548.949333,1028.696 L624.362667,953.282667 L813.589333,1142.50933 L1301.056,772.482667 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconCertifiedLine = /*#__PURE__*/function (_Component) {
  _inherits(IconCertifiedLine, _Component);

  var _super = _createSuper(IconCertifiedLine);

  function IconCertifiedLine() {
    _classCallCheck(this, IconCertifiedLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconCertifiedLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconCertified",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconCertifiedLine.displayName = "IconCertifiedLine";
  return IconCertifiedLine;
}(Component);

IconCertifiedLine.glyphName = 'certified';
IconCertifiedLine.variant = 'Line';
IconCertifiedLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconCertifiedLine;
export { IconCertifiedLine };